var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0286 13.1318C14.8538 11.7714 14.0349 11.0856 14.0349 7.33042C14.0349 3.90131 12.1836 2.67583 10.6646 2.07995C10.4628 2.00125 10.273 1.82136 10.2136 1.61899C9.94067 0.753279 9.19302 0 8.20803 0C7.22304 0 6.46353 0.753279 6.20245 1.61899C6.14311 1.82136 5.95323 1.99001 5.75149 2.06871C4.23247 2.66458 2.38116 3.87883 2.38116 7.31918C2.38116 11.0631 1.55044 11.7601 0.375573 13.1205C-0.110989 13.6827 0.316236 14.5259 1.15882 14.5259H15.2454C16.088 14.5259 16.5152 13.6827 16.0286 13.1205V13.1318Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1155 15.2342C11.1155 15.965 10.807 16.6733 10.2611 17.1905C9.71519 17.7077 8.96755 18 8.19617 18C7.42479 18 6.67714 17.7077 6.13124 17.1905C5.58535 16.6733 5.27679 15.965 5.27679 15.2342",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3964b556ff06ff3f5f25a45537247788.svg";
export { ForwardRef as ReactComponent };